import { baseURL } from './baseUrl';

export const apiCreateUser = async (userData: object) => {
    const response = await baseURL.post('create', userData);
    return response.data;
};
